import { render, staticRenderFns } from "./n-radio.vue?vue&type=template&id=3432017b&lang=pug&"
import script from "./n-radio.vue?vue&type=script&lang=js&"
export * from "./n-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports